import { render } from "./AccountPortfolio.vue?vue&type=template&id=f6b05c9a&scoped=true"
import script from "./AccountPortfolio.vue?vue&type=script&lang=js"
export * from "./AccountPortfolio.vue?vue&type=script&lang=js"

import "./AccountPortfolio.vue?vue&type=style&index=0&id=f6b05c9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b05c9a"]])

export default __exports__